import React from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

export default function CollectionSearch({ value, onChange, label = 'Search', shown, total, sx }) {
  return (
    <TextField
      type="search" label={label} value={value} size="small" fullWidth
      onChange={event => onChange(event.target.value)}
      helperText={value.trim() && total != null ? `${shown} of ${total} shown` : undefined}
      sx={{ mb: 2, ...sx }}
      InputProps={{
        startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>,
        endAdornment: value ? <InputAdornment position="end">
          <IconButton size="small" aria-label={`Clear ${label.toLowerCase()}`} onClick={() => onChange('')}>
            <ClearIcon fontSize="small" />
          </IconButton>
        </InputAdornment> : undefined,
      }}
    />
  );
}
